
export const NID_REGEXP = /^([a-z]|å|ä|ö|ø|æ|[0-9]|-|_| )+$/i
